import React, { useEffect } from "react";
import ReactExport from "react-data-export";
import { makeStyles } from '@material-ui/core/styles';
import { MuiButton, MuiGetApp } from '../../../ui/MaterialUIComponents';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const useStyles = makeStyles(theme => ({
    iconStyle: { color: 'white', height: '30', width: '25px' },
    iconButtonStyle: {
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        },
        background: theme.palette.primary.main, width: '20px'
    },

}));
export default function ExcelFileDownload(props) {
    const [sheet, setSheet] = React.useState("");
    const [data, setData] = React.useState([]);

    const classes = useStyles();

    const setDataSet = () => {
        setData(props.dataSet)
        setSheet(props.sheetName)
       
    }
    useEffect(() => {
        setDataSet();
    }, []);
    return (
        <div>{sheet!=undefined ?

            <ExcelFile element={<MuiButton className={classes.iconButtonStyle}><MuiGetApp className={classes.iconStyle}></MuiGetApp></MuiButton>}>
                <ExcelSheet dataSet={data} name={sheet} />

            </ExcelFile> : null}

        </div>
    );
}
